import React from "react";
import { useSearchParams } from "react-router-dom";
import DictionaryEntryForm from "../../components/dictionaries/DictionaryEntryForm";
import PremiumFormPanel from "../../components/PremiumFormPanel";
import useDictionaryFormData from "../../hooks/useDictionaryFormData";

/** Odczytuje edytowany wpis również po wejściu bezpośrednim adresem strony. */
export default function EditDictionaryEntryPage({
  organization,
  token,
  definition,
  listPath,
}) {
  const [params] = useSearchParams();
  const entryKey = params.get("key");
  const resource = useDictionaryFormData(organization, token, definition.kind);
  const entry = resource.entries.find((item) => item.key === entryKey);
  const error =
    resource.accessError ||
    (resource.data && !entry
      ? "Nie znaleziono wpisu. Mógł zostać usunięty."
      : "");
  return (
    <PremiumFormPanel
      title={`Edytuj wpis — ${definition.label}`}
      description="Zmiana będzie dostępna w nowych zleceniach."
      resource={resource}
      error={error}
      loadingLabel="Ładowanie wpisu…"
      backTo={listPath}
    >
      <DictionaryEntryForm
        key={entryKey}
        token={token}
        url={resource.url}
        definition={definition}
        initialEntry={entry}
        entries={resource.entries}
        listPath={listPath}
      />
    </PremiumFormPanel>
  );
}
